export default "__VITE_ASSET__DKCzRw8j__"